import { InfoOutlined } from '@mui/icons-material';
import { Box, Chip, Tooltip, darken, lighten } from '@mui/material';
import { useTranslation } from 'react-i18next';

type SmsSubscriptionHandlerProps = {
  unsubscribed?: boolean | null;
};

export const SmsSubscriptionHandler = (props: SmsSubscriptionHandlerProps) => {
  const { unsubscribed } = props;
  const { t } = useTranslation();

  if (unsubscribed !== true) return null;

  return (
    <Box sx={{ marginLeft: 1, display: 'inline-flex' }}>
      <Tooltip title={t('member:smsSubscription.unsubscribedDetailed')} arrow placement='right-start'>
        <Chip
          icon={<InfoOutlined fontVariant='outlined' />}
          label={t('member:smsSubscription.unsubscribed')}
          sx={{
            backgroundColor: (thm) => lighten(thm.palette.warning.main, 0.8),
            color: (thm) => darken(thm.palette.warning.main, 0.5),
            fontSize: (thm) => thm.typography.caption.fontSize,
            fontWeight: (thm) => thm.typography.fontWeightMedium,
          }}
          size='small'
        />
      </Tooltip>
    </Box>
  );
};
